import { IndexApiSet, useIndexApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { Disease } from 'entities/disease'

type DiseasesResponse = PagingResponse & {
    results: Disease[]
}

export function useFetchDiseasesApi(): IndexApiSet<DiseasesResponse> & {
    execute: () => void
} {
    const apiPath = 'diseases/'
    const api = useIndexApi<DiseasesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}
